import { defineStore } from 'pinia'
import axios from 'axios'

export const useBalancedLinesStore = defineStore('balancedLines', {
  state: () => ({
    balancedLines: [],
    loading: false,
    error: null
  }),

  getters: {
    getBalancedLines: (state) => state.balancedLines,
    isLoading: (state) => state.loading,
    getError: (state) => state.error
  },

  actions: {
    async fetchBalancedLines() {
      this.loading = true
      this.error = null
      try {
        const response = await axios.get('/balanced-lines')
        this.balancedLines = response.data
      } catch (error) {
        this.error = error.message || 'Failed to fetch balanced lines'
        console.error('Error fetching balanced lines:', error)
      } finally {
        this.loading = false
      }
    },

    async updateBalancedLine(id, data) {
      this.loading = true
      this.error = null
      try {
        const response = await axios.put(`/balanced-lines/${id}`, data)
        const index = this.balancedLines.findIndex(bl => bl.id === id)
        if (index !== -1) {
          this.balancedLines[index] = response.data
        }
      } catch (error) {
        this.error = error.message || 'Failed to update balanced line'
        console.error('Error updating balanced line:', error)
      } finally {
        this.loading = false
      }
    },

    async createBalancedLine(data) {
      this.loading = true
      this.error = null
      try {
        const response = await axios.post('/balanced-lines', data)
        this.balancedLines.push(response.data)
      } catch (error) {
        this.error = error.message || 'Failed to create balanced line'
        console.error('Error creating balanced line:', error)
      } finally {
        this.loading = false
      }
    },

    async deleteBalancedLine(id) {
      this.loading = true
      this.error = null
      try {
        await axios.delete(`/balanced-lines/${id}`)
        this.balancedLines = this.balancedLines.filter(bl => bl.id !== id)
      } catch (error) {
        this.error = error.message || 'Failed to delete balanced line'
        console.error('Error deleting balanced line:', error)
      } finally {
        this.loading = false
      }
    }
  }
}) 